module.exports = __webpack_public_path__ + "img/custom_page_layout1.51788e42.png";